const com30 = {
    code: "30",
    length: { min: 16, max: 20 },
    payload: [
        { name: "código", type: "bytes", length: 1, description: "Código de configuración (1 byte).", pad: "00" },
        { name: "ictime", type: "bytes", length: 2, description: "Empieza a medir desde ictime (en minutos). ictime = 0000 es medianoche", range: { min: 0, max: 1439 }, pad: "0000" },
        { name: "icnum", type: "bytes", length: 1, description: "Número de medidas tras el inicio", pad: "00" },
        { name: "icmina", type: "bytes", length: 2, description: "Medida cada icmina (en minutos)", range: { min: 1, max: 1439 }, pad: "0000" },
        { name: "icminb", type: "bytes", length: 2, description: "Medida cada icminb tras capturar el número de medidas indicado en icnum (minutos)", range: { min: 1, max: 1439 }, pad: "0000" },
    ],
};

export default com30;